import { APIClient } from '@frontend/api-utils';

export class EquipmentEnumClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async fetchEquipmentStates(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/equipment-states`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchEquipmentTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/equipment-triggers`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchEquipmentActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/equipment-actions`);
        return await this.handleResponse<string[]>(response);
    }
}
